import EduVsNetwork from "./EduVsNetwork";
export default EduVsNetwork;
